<template>
  <!-- <v-daterange v-model="dateRange" :label="label"></v-daterange> -->
  <v-date-picker v-model="dateRange" :label="label" range></v-date-picker>
</template>
<!-- <v-text-field @click="showDateRange" :label="label"> </v-text-field>

    <date-range-picker
      style="position:absolute;z-Index:0;top:0;display:none"
      refs="rangePicker"
      v-model="dateRange"
      :opens="opens"
      :append-to-body="true"
    ></date-range-picker> -->

<script>
// import DateRangePicker from "vue2-daterange-picker";
// //you need to import the CSS manually (in case you want to override it)
// import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import { VDaterange } from "vuetify-daterange-picker";
// import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css";
export default {
  name: "dateRangeControl",
  props: {
    dateRangeData: Object,
    dateRangeLabel: String
  },
  //   components: { VDaterange },
  data() {
    var that = this;
    return {
      dateRange: { startDate: "", endDate: "" },
      opens: "right",
      "append-to-body": true,
      label: "",
      hasValue: true,
      show: false,
      doOnLoad() {
        console.log("date picker loaded");
      },
      showDateRange() {
        that.show = !that.show;
        if (that.show) {
          console.log(that.$refs);
          //   that.$refs.dateRange.click();
        }
      }
    };
  },
  mounted() {
    // console.log(this.$props.dateRangeData);
    // console.log(this.$props.dateRangeLabel);
    // if (this.$props.range) {
    // this.dateRange.startDate = this.$props.dateRangeData.startDate;
    // this.dateRange.endDate = this.$props.dateRangeData.endDate;
    // this.label = this.$props.dateRangeLabel;
    // console.log(this.dateRange);
    // console.log(this.$refs);
    // }
  },
  methods: {
    // dateFormat(classes, date) {
    //   console.log(date);
    //     if (!classes.disabled) {
    //       classes.disabled = date.getTime() < new Date();
    //     }
    //   return classes;
    // },
    today() {
      var d = new Date();
      return d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
    }
  }
};
</script>

<style>
@import "https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css";
</style>
